import { Observable } from 'rxjs/Observable';
import { Store } from 'redux';
import { ActionsObservable } from 'redux-observable';
import {
    EditMessageRequest,
    editMessageSuccess,
    editMessageFailure,
    MessageAction,
  } from '../actions';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';  
import 'rxjs/add/operator/catch';
import { AjaxCreationMethod, AjaxResponse } from 'rxjs/observable/dom/AjaxObservable';
import { AppState, AuthState } from '../models';
import { EDIT_MESSAGE_REQUEST } from '../constants';
import { getCannedMessageEndpoint } from '../configs';
import * as epicCommon from './epicCommon';
import * as errorUtil from '../utils/errorUtil';


export const editMessage = (action$: ActionsObservable<MessageAction>,
                            store: Store<AppState>,
                            ajax: AjaxCreationMethod): Observable<MessageAction> => {
  return action$.ofType(EDIT_MESSAGE_REQUEST)
    .mergeMap((editRequest: EditMessageRequest) => {
      const state: AuthState = store.getState().authState;
      const endpoint = getCannedMessageEndpoint();
      const messageId = editRequest.message.id;
      const messageText = editRequest.message.text;
      const url =  `${endpoint}canned-messages/${messageId}`;
      return ajax.put(url,
                      { text: messageText, categories: (editRequest.message.categories || []) },
                      epicCommon.getHttpHeaders(state.authToken),
      )
          .map((res: AjaxResponse) => editMessageSuccess(editRequest.message))
          .catch((err) => { 
            errorUtil.throwErrorAsync(err);
            return Observable.of(editMessageFailure(epicCommon.extractMessage(err)));
          },
        );
    });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/editMessage.ts